// permissions.js
export const PermissionBits = {
  0: "NONE",
  1: "VIEW",
  2: "ADD",
  4: "MODIFY",
  8: "DELETE",
  16: "REPORTS",
  32: "LOCK",
  64: "FIND",
  128: "TABLEVIEW",
  256: "UNLOCK",
  512: "PRINT",
  1023: "ALL",
};

export const Permissions = {
  NONE: 0,
  VIEW: 1,
  ADD: 2,
  MODIFY: 4,
  DELETE: 8,
  REPORTS: 16,
  LOCK: 32,
  FIND: 64,
  TABLEVIEW: 128,
  UNLOCK: 256,
  PRINT: 512,
  ALL: 1023,
};

export const Security_Types = {
  criteria: "Criteria",
  functionality: "Functionality",
  record: "Record",
  clientParams: "clientParameter",
};

export const Entity_types = {
  arbitary: "Arbitrary",
  module: "Module",
  subModule: "SubModule",
  field: "field",
};

export const Arbitrary_Names = {
  DisplayRebookButton: "DisplayRebookButton",
  DisplayReleaseButton: "DisplayReleaseButton",
  DisplayExportMenu: "DisplayExportMenu",
  EditLogin: "EditLogin",
  EnableDeleteCharges: "EnableDeleteCharges",
  HideVictimNotifications: "HideVictimNotifications",
  ModifyInmateClassifications: "ModifyInmateClassification",
  ViewMedicalInfo: "ViewMedicalInfo",
  ShowSecurityInStaffModule: "ShowSecurityInStaffModule",
  divArrestCharges: "divArrestCharges",
  divArrestChargesBond: "divArrestChargesBond",
  divInmateBilling: "divInmateBilling",
  divScheduledEvents: "divScheduledEvents",
  divSignatures: "divSignatures",
  divPersonalInfoEmergency: "divPersonalInfoEmergency",
  divJailIncidentsSupplementals: "divJailIncidentsSupplementals",
  InmateRelease: "InmateRelease",
  SupView: "Sup-View",
  AdminView: "Admin-View",
  FacilityLogSuper: "FacilityLogSuper",
  // ASP's UtilKeyboardCommon.asp gate for Ctrl-L/S/E (see
  // ContainerCommon.vbs/IsThisArbitaryFunctionSetLocal, "CanIPerformShortCut").
  // Only client DBs that explicitly restrict it (e.g. Anoka) have a rule
  // configured, so hasCheckSecurity's "no rule -> allow" default keeps the
  // shortcut working everywhere else. Do not pass startingPoint=true for
  // this identifier or it will invert to deny-by-default.
  CanIPerformShortCut: "CanIPerformShortCut",
  ShowRestrictedMedicalFlags: "ShowRestrictedMedicalFlags",
  TransportAdmin: "TransportAdmin",
  LinkedDocumentsSuper: "LinkedDocumentsSuper",
  LinkedDocumentsSignPDF: "LinkedDocumentsSignPDF",
  CanDeleteCashAccount: "CanDeleteCashAccount",
  CanDeleteTrustAccount: "CanDeleteTrustAccount",
};
